/**
 * Shape design tokens from Figma (Queen One Design System).
 * Source: Shape variable collection.
 */

export const shape = {
  borderRadius: {
    none: 0,
    sm: 4,
    md: 8,
    lg: 16,
    buttonCorner: 200,
  },
} as const;
